module.exports = __webpack_public_path__ + "6725fc490942895a65f559882a17d524.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/LightItalic/OpenSans-LightItalic.eot
// module id = 978
// module chunks = 0